export class LastestPin extends HTMLElement {

  static get observedAttributes() {
    return ['image'];
  }
  constructor() {
    super();
  }


  handleEvent(event) {
    if (event.type === 'click') {
      const evt = new CustomEvent("onClickWrapper", {
        bubbles: true,
        cancelable: false,
        composed: true
      });
      this.dispatchEvent(evt);
    }
  }

  attributeChangedCallback() {
    this.image = this.getAttribute('image')
    this.name = this.getAttribute('name')
    this.connectedCallback();
  }


  connectedCallback() {
    if (this.image) {
      this.innerHTML = `
        <style>
          .lastest-pin-wrapper {
            background: url(${this.image});
            background-size: cover !important;
            border-radius: 8px;
            height: 100px;
            margin-bottom: 16px;
            cursor: pointer;
          }
          .lastest-pin-wrapper h4, .lastest-pin-wrapper h3 {
            color: #dfdfdf;
            text-align: right;
            padding: 10px 15px;
            margin: 0;
            font-weight: 100;
            text-shadow: 0 0 1px black;
          }
          .lastest-pin-wrapper h3 {
            color: white;
            padding: 0 15px;
          }
        </style>
        <div class="lastest-pin-wrapper click">
          <h4>Lastest Pin</h4>
          <h3>${this.name}</h3>
        </div>
      `
      this.querySelectorAll('.click').forEach(node => node.addEventListener("click", this))
    } else {
      this.innerHTML = ''
    }
  }
}

  window.customElements.define("lastest-pin", LastestPin);
